import React from "react";
import { useEffect, useState } from "react";
import Image from "next/image";
import Head from "next/head";
import { NextPage, GetServerSideProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import styles from "./index.module.scss";
import one from "@images/home/22@2x.png";
import { getBlogs } from "@/service/index";
import Layout from "@/components/layout";
import Link from "next/link";
import { useRouter } from "next/router";
import { useWidth } from "@/utils/resize";
import dayjs from "dayjs";
import { getLangLink } from "@/utils/lang";
import Pagination from "@/components/Pagination";

import down from "@images/ic_drop_down@2x.png";

const Blog: NextPage<{
  blogs: any[];
  total: number;
  current: number;
  size: number;
}> = (props) => {
  const { t } = useTranslation("blog");
  const { blogs, total, current, size } = props;
  const router = useRouter();
  const { locales, locale: activeLocale } = router;
  const { width, display } = useWidth();
  /**
   * @description: rc-paginaion里面的方法 作用：修改分页里面的<a>标签让他拥有href 利于seo
   * @param {any} current
   * @param {any} type
   * @param {any} element
   * @return {*}
   */

  const [xValue, setXValue] = useState(false); //false 表示大于768px
  //解决768px blog主图不能全屏
  useEffect(() => {
    const handleResize = (setXValue: any) => {
      if (typeof window !== "undefined") {
        var screenW = document.body.clientWidth;
        if (screenW <= 768) {
          setXValue(true);
        } else {
          setXValue(false);
        }
      }
    };
    handleResize(setXValue);
    window.addEventListener("resize", (e) => handleResize(setXValue), false);
    return () => {
      window.addEventListener("resize", (e) => handleResize(setXValue), false);
    };
  }, []);

  return (
    <div>
      <Layout header={true} footer={true}>
        <Head>
          <title>{t("seo blog title")}</title>
          <meta name="keywords" content={t("seo blog keywords")} />
          <meta name="description" content={t("seo blog description")} />
          
        </Head>
        <div className={styles.blogs + " relative"}>
          {/* 版心 */}
          <div className={styles.container + " defeaultContainer"}>
            <div className="text-[14px] leading-[21px]">
              <a
                href={process.env.portalUrl + getLangLink("", activeLocale)}
                className="!text-[#708096] hover:!text-[#ff3e5f]"
              >
                {t("Home")}
              </a>
              <span className="text-[#708096]"> / </span>
              <span className="text-[#2E384E]">{t("Blogs")}</span>
            </div>
            <div className={styles.title + " pt-[28px]"}>{t("blogTitle")}</div>
            <div className={styles.title1}>
              <span>{t("blogTip")}</span>
            </div>
            {/* 渲染报告列表 */}
            <div className={styles.blogList}>
              {blogs && blogs.length > 0
                ? blogs.map((item, index) => (
                    <a
                      key={index}
                      href={getLangLink(`/blogs/${item.seoUrl}`, activeLocale)}
                      title={item.seoTitle}
                      className={styles.blogItem}
                    >
                      <div className={styles.item} key={index}>
                        <div className={styles.itemTop}>
                          <div className={styles.pic}>
                            <a
                              href={getLangLink(
                                `/blogs/${item.seoUrl}`,
                                activeLocale
                              )}
                              title={item.seoTitle}
                              className={` block leading-none relative`}
                            >
                              <Image
                                lazyBoundary="10px"
                                src={item.cover ? item.cover : one}
                                alt={item.seoTitle}
                                width={width > 1024 ? 335 : 117}
                                height={width > 1024 ? 234 : 82}
                                objectFit="cover"
                                style={{
                                  borderRadius: width < 1024 ? "8px" : "0px",
                                }}
                              ></Image>
                            </a>
                          </div>
                          <div className={styles.itemInfo}>
                            <div className={styles.title}>{item.title}</div>
                            <div className={styles.time}>
                              {item.createTime
                                ? dayjs(item.createTime).format("YYYY-MM-DD ")
                                : ""}
                            </div>
                          </div>
                        </div>
                        <div className={styles.itemBottom}>
                          <div
                            className={
                              styles.desc +
                              " lg1024:!min-h-0 lg1024:!text-[14px] lg1024:!leading-[20px]"
                            }
                          >
                            {item.desc}
                          </div>
                        </div>
                      </div>
                    </a>
                  ))
                : null}
            </div>
            <div className="py-[26px] mt-[30px] bg-[#ffffff] rounded-[8px] minlg1024:mb-[74px] lg1024:pb-[27px]">
              <Pagination
                current={Number(current)}
                total={total}
                size={size}
              ></Pagination>
            </div>
          </div>
        </div>
      </Layout>
    </div>
  );
};
export const getServerSideProps: GetServerSideProps = async (context) => {
  const { locale, params, query } = context;
  /**
   * @description: 获取bolg列表
   * @return {*}
   */
  let res = await getBlogs({
    language: "en",
    pageSize: query?.size || 8,
    pageNum: query?.page || 1,
    context,
    type: 0, // 0: 博客 1： 报告
  });
  let total = 0;
  let blogs: any[] = [];
  let current: number = 0;
  let size: number = query?.size ? parseInt(query?.size as string) : 8;
  // console.log(res);

  if (res && res.code == 0) {
    let { items, totalCount }: { items: any; totalCount: any } = res?.data;
    total = totalCount;
    blogs = items ? items : [];
    current = parseInt(query?.page as string) || 1;
  }
  return {
    props: {
      ...(await serverSideTranslations(locale!, [
        "common",
        "nav",
        "blog",
        "footer",
      ])),
      blogs,
      total,
      current,
      size,
    },
  };
};

export default Blog;
